import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { registerPWAUpdate, applyPWAUpdate } from './pwa-update'
import './styles/global.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)

registerPWAUpdate(() => {
  const toast = document.createElement('div')
  toast.className = 'pwa-update-toast'
  toast.innerHTML = `
    <span>Nouvelle version disponible</span>
    <button data-action="apply">Mettre à jour</button>
    <button data-action="dismiss">Plus tard</button>
  `
  toast.querySelector('[data-action="apply"]')?.addEventListener('click', () => applyPWAUpdate())
  toast.querySelector('[data-action="dismiss"]')?.addEventListener('click', () => toast.remove())
  document.body.appendChild(toast)
})
